import React, { Component } from 'react'
import Page from 'components/Page'
import CmsSection from '../CmsSection'
import Footer from 'components/Footer'
import { get } from 'lodash'

const TITLE_SEPARATOR = ' : '

export default class CmsPage extends Component {
  constructor(props) {
    super(props)

    const { page, location } = this.props
    const chunks = [page.fields.title]

    // we need to look through all Tabs sections and build initial title for SSR
    page.fields.sections.forEach(section => {
      // only Tabs affect page title
      if (section.sys.contentType !== 'sectionTabs') return

      const { tabTitles = [], queryParam } = section.fields
      const activeLabel = get(location, ['query', queryParam])
      const index = tabTitles.findIndex(
        item => item.id === activeLabel || item.label === activeLabel
      )

      // do not change title if there is no query param
      if (index === -1) return

      chunks.push(tabTitles[index].label)
    })

    this.state = {
      title: chunks.join(TITLE_SEPARATOR),
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.page.fields.title !== this.props.page.fields.title) {
      this.setState({
        title: nextProps.page.fields.title,
      })
    }
  }

  // this method will be used by Tabs component to change page title dynamically
  // method will append given title to the original one with separator
  appendToPageTitle = (title, separator = TITLE_SEPARATOR) => {
    const chunks = [this.props.page.fields.title]
    if (title) {
      chunks.push(title)
    }
    this.setState({ title: chunks.join(separator) })
  }

  render() {
    const { page, location } = this.props
    if (page) {
      return (
        <Page
          layout={{ header: 'landing' }}
          title={this.state.title}
          image={page.fields.image}
          description={`${page.fields.description} | ${this.state.title}`}
        >
          {page.fields.sections.map((section, idx) => (
            <CmsSection
              key={`${section.sys.id}-${idx}`}
              section={section}
              location={location}
              // share method with children as a prop
              appendToPageTitle={this.appendToPageTitle}
            />
          ))}
          <Footer />
        </Page>
      )
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/CmsPage/CmsPage.jsx